import React, { useContext } from 'react'
import { Route, Switch } from 'react-router-dom'
import { Home } from '../pages/Home/Home'
import { Paths } from './paths'
import { Login } from '../pages/Login/Login'
import { ForgotPassword } from '../pages/ForgotPassword'
import { NotFound } from '../pages/NotFound/NotFound'
import { TemporaryLogin } from '../pages/AccountSetup/TemporaryLogin'
import { ChangePassword } from '../pages/AccountSetup/ChangePassword'
import Quotes from '../pages/Quotes/Quotes'
import QuoteForm from '../pages/QuoteForm/QuoteForm'
import { AuthContext } from '../context/Auth'
import { CenteredSpinner } from 'react-angle-dashboard-components'
import { DocumentsAndForms } from '../pages/GroupAccess/Documents'
import { Summary } from '../pages/GroupAccess/Summary'
import Employees from '../pages/GroupAccess/Employees'
import { DisenrollEmployee } from '../pages/GroupAccess/Employees/DisenrollEmployee/DisenrollEmployee'
import Billing from '../pages/GroupAccess/Billing'
import { EmployeeRegistration } from '../pages/GroupAccess/EmployeeRegistration'
import { EmployeeProfile } from '../pages/GroupAccess/EmployeeProfile'
import { EditEmployee } from '../pages/GroupAccess/EditEmployee'
import EditDependent from '../pages/GroupAccess/Dependents/EditDependent'
import { DependentProfile } from '../pages/GroupAccess/Dependents/DependentProfile'
import { EmployeeProfileIdCard } from '../pages/GroupAccess/EmployeeProfile/EmployeeProfileIdCard'
import ViewQuote from '../pages/ViewQuote/ViewQuote'
import ResetPassword from '../pages/ResetPassword'
import ReportingPage from '../pages/Reporting/ReportingPage'
import TempAuth from '../pages/TempAuth/TempAuth'

export const Router = () => {
  const { authLoading } = useContext(AuthContext)
  if (authLoading) {
    return <CenteredSpinner />
  }
  return (
    <Switch>
      <Route path={Paths.login} component={Login} />
      <Route path={Paths.temporaryLogin} component={TemporaryLogin} />
      {/* GROUP SPECIFIC ROUTES */}
      <Route path={Paths.documentsAndForms} component={DocumentsAndForms} />
      <Route path={Paths.summary} component={Summary} />
      <Route path={Paths.billing} component={Billing} />
      <Route path={Paths.editEmployeeProfile} component={EditEmployee} />
      <Route path={Paths.editDependentProfile} component={EditDependent} />
      <Route
        path={Paths.employeeProfileIdCard}
        component={EmployeeProfileIdCard}
      />
      <Route
        path={Paths.dependentProfileIdCard}
        component={EmployeeProfileIdCard}
      />
      <Route path={Paths.dependentProfile} component={DependentProfile} />
      <Route
        path={Paths.newEmployeeRegistration}
        component={EmployeeRegistration}
      />
      <Route exact path={Paths.employeeProfile} component={EmployeeProfile} />
      <Route path={Paths.disenrollEmployee} component={DisenrollEmployee} />
      <Route path={Paths.employees} component={Employees} />
      <Route path={Paths.reporting} component={ReportingPage} />
      {/* GROUP SPECIFIC ROUTES */}
      <Route path={Paths.forgotPassword} component={ForgotPassword} />
      <Route path={Paths.resetPassword} component={ResetPassword} />
      <Route path={Paths.changePassword} component={ChangePassword} />
      <Route exact path={Paths.home} component={Home} />
      <Route exact path={Paths.quotes} component={Quotes} />
      <Route exact path={Paths.viewQuote()} component={ViewQuote} />
      <Route path={Paths.quoteForm()} component={QuoteForm} />
      <Route path={Paths.superuser} component={TempAuth} />
      <Route component={NotFound} />
    </Switch>
  )
}
